
import { Vue, Component, Prop } from 'vue-property-decorator'
import DashboardTeacher from '../../components/Dashboards/DashboardTeacher.vue'
  @Component({
    name: 'student',
    components: { DashboardTeacher }
  })
export default class student extends Vue {
  mounted() {}
}
